export const faq = [
  {
    category: 'about',
    question: 'O que é o sistema e para quem ele é indicado?',
    answers: [
      {
        type: 'paragraph',
        content:
          'Nosso sistema de administração de obras é uma plataforma web desenvolvida para facilitar a gestão e o controle de projetos de construção. Ele permite acompanhar o andamento das obras, gerenciar custos, controlar prazos, compartilhar fotos e documentos, além de gerar relatórios detalhados.',
      },
      {
        type: 'paragraph',
        content:
          'O sistema é indicado para engenheiros, arquitetos, construtoras, empreiteiros e qualquer profissional ou empresa que precise otimizar a administração de seus projetos de construção. Com uma interface intuitiva e funcionalidades completas, ele aumenta a produtividade e garante melhor transparência e controle financeiro da obra.',
      },
    ],
  },
  {
    category: 'client',
    question: 'Como faço para cadastrar um novo cliente no sistema?',
    answers: [
      {
        type: 'paragraph',
        content: 'Para cadastrar um novo cliente, siga estes passos simples:',
      },
      {
        type: 'list',
        items: [
          'Acesse o sistema com seu login e senha.',
          'No menu principal, clique na opção "Clientes".',
          'Selecione "Cadastrar Cliente".',
          'Preencha as informações necessárias, como nome, telefone, e-mail, endereço, CPF ou CNPJ.',
          'Defina se o cliente terá acesso ao sistema e configure suas permissões de uso.',
          'Clique em "Salvar" para concluir o cadastro.',
        ],
      },
      {
        type: 'paragraph',
        content:
          'Após o cadastro, o cliente ficará disponível na lista do sistema, permitindo que você associe obras a ele.',
      },
    ],
  },
  {
    category: 'construction',
    question: 'Como faço para cadastrar uma nova obra no sistema?',
    answers: [
      {
        type: 'paragraph',
        content: 'Para cadastrar uma nova obra, siga estes passos simples:',
      },
      {
        type: 'list',
        items: [
          'Acesse o sistema com seu login e senha.',
          'No menu principal, clique na opção "Obras".',
          'Selecione "Cadastrar Obra".',
          'Preencha as informações essenciais, como nome da obra, endereço, responsável e descrição.',
          'Associe um ou mais clientes à obra.',
          'Anexe uma imagem da obra.',
          'Clique em "Salvar" para concluir o cadastro.',
        ],
      },
      {
        type: 'paragraph',
        content:
          'Após o cadastro, a obra ficará disponível no sistema, permitindo o acompanhamento do andamento, registro de despesas e compartilhamento de documentos. Além disso, é possível criar orçamentos para um melhor planejamento e controle financeiro da obra.',
      },
    ],
  },
  {
    category: 'category',
    question: 'Como faço para criar uma categoria?',
    answers: [
      {
        type: 'paragraph',
        content: 'Para criar uma nova categoria no sistema, siga estes passos:',
      },
      {
        type: 'list',
        items: [
          'Acesse o sistema com seu login e senha.',
          'No menu principal, clique na opção "Categorias".',
          'Selecione "Nova Categoria".',
          'Insira o nome da categoria.',
          'Clique em "Salvar" para finalizar a criação.',
        ],
      },
      {
        type: 'paragraph',
        content:
          'Após criada, a categoria pode ser associada a fornecedores para organizar melhor os dados no sistema e facilitar a busca de lançamentos.',
      },
    ],
  },
  {
    category: 'password',
    question: 'Como faço para alterar a minha senha?',
    answers: [
      {
        type: 'paragraph',
        content: 'Para alterar sua senha no sistema, siga estes passos:',
      },
      {
        type: 'list',
        items: [
          'Acesse o sistema com seu login e senha.',
          'No menu principal, clique na opção "Configurações".',
          'Selecione "Alterar Senha".',
          'Insira sua senha atual.',
          'Digite a nova senha e confirme-a.',
          'Clique em "Salvar" para concluir a alteração.',
        ],
      },
      {
        type: 'paragraph',
        content:
          'Após a alteração, sua nova senha será aplicada imediatamente. Caso esqueça sua senha, utilize a opção "Recuperar Senha" na tela de login para redefini-la.',
      },
    ],
  },
  {
    category: 'customization',
    question: 'Como personalizo o meu sistema?',
    answers: [
      {
        type: 'paragraph',
        content:
          'Para personalizar o sistema de acordo com as suas necessidades, siga estes passos:',
      },
      {
        type: 'list',
        items: [
          'Acesse o sistema com seu login e senha.',
          'No menu principal, clique em "Configurações".',
          'Acesse a seção "Personalização do Sistema".',
          'Escolha as opções disponíveis, como: Adicionar o logotipo da sua empresa ou Definir cores do sistema.',
          'Após realizar as alterações desejadas, clique em "Salvar" para aplicar as configurações.',
        ],
      },
      {
        type: 'paragraph',
        content: 'Com essas opções, deixe o sistema com a sua identidade.',
      },
    ],
  },
  {
    category: 'payables',
    question: 'Como faço um novo lançamento?',
    answers: [
      {
        type: 'paragraph',
        content: 'Para criar um novo lançamento no sistema, siga estes passos:',
      },
      {
        type: 'list',
        items: [
          'Acesse o sistema com seu login e senha.',
          'Acesse a tela Home ou a tela da Obra.',
          'Selecione "Novo Lançamento".',
          'Preencha as informações necessárias, como: Obra, Fornecedor, Valor, Data, Categoria, Descrição etc.',
          'Clique em "Salvar" para concluir o lançamento ou "Salvar e Anexar" para anexar notas, boletos, comprovantes etc.',
        ],
      },
      {
        type: 'paragraph',
        content:
          'Se optar por fazer um lançamento na página Home, é possível subir um boleto no campo pontilhado "Arraste o boleto", e o OCR fará a leitura dos dados de forma automática. Caso o fornecedor esteja cadastrado corretamente no sistema, alguns campos serão preenchidos, como Obra, Fornecedor, Código do boleto, Categoria do fornecedor, Vencimento e Valor.',
      },
    ],
  },
  {
    category: 'budget',
    question: 'Como crio orçamentos?',
    answers: [
      {
        type: 'paragraph',
        content: 'Para criar um novo orçamento no sistema, siga estes passos:',
      },
      {
        type: 'list',
        items: [
          'Acesse o sistema com seu login e senha.',
          'No menu principal, clique em "Obras".',
          'Selecione a Obra.',
          'Selecione a aba "Orçamentos".',
          'Selecione "Copiar Orçamento" para copiar um orçamento existente de outra obra ou para selecione “Novo Orçamento” para criar um novo orçamento .',
          'Preencha as informações necessárias.',
          'Clique em "Salvar Orçamento".',
        ],
      },
      {
        type: 'paragraph',
        content:
          'Após salvo, o orçamento pode ser editado, atualizado e utilizado para acompanhar os custos da obra.',
      },
    ],
  },
  {
    category: 'payables',
    question:
      'O valor total lançado não coincide com o campo "Total executado", o que pode estar acontecendo?',
    answers: [
      {
        type: 'paragraph',
        content:
          'Se o valor total lançado não está batendo com o campo "Total executado", algumas situações podem estar causando essa diferença:',
      },
      {
        type: 'list',
        items: [
          'Filtros aplicados: Confirme se há filtros de data, categoria ou fornecedor que podem estar excluindo alguns lançamentos da visualização.',
          'Lançamentos não vinculados: Certifique-se de que todos os lançamentos estão corretamente associados aos itens do orçamento.',
        ],
      },
      {
        type: 'paragraph',
        content:
          'Se, após essas verificações, o problema persistir, entre em contato com o suporte para uma análise mais detalhada.',
      },
    ],
  },
  {
    category: 'payables',
    question:
      'Na tela de lançamentos não estão aparecendo todos os lançamentos, o que pode estar acontecendo?',
    answers: [
      {
        type: 'paragraph',
        content:
          'Se alguns lançamentos não estão sendo exibidos na tela, considere a seguinte possibilidade:',
      },
      {
        type: 'list',
        items: [
          'Filtros aplicados: Verifique se há filtros de data, categoria, fornecedor, obra, status de pagamento ou item do orçamento que possam estar limitando a exibição dos lançamentos.',
        ],
      },
      {
        type: 'paragraph',
        content:
          'Caso tenha verificado esse ponto e o problema persistir, entre em contato com o suporte para uma análise mais detalhada.',
      },
    ],
  },
  {
    category: 'client',
    question: 'Como crio o login de acesso para meu cliente?',
    answers: [
      {
        type: 'paragraph',
        content:
          'Para criar um login de acesso para seu cliente, siga estes passos:',
      },
      {
        type: 'list',
        items: [
          'Acesse o sistema com seu login e senha.',
          'No menu principal, clique em "Clientes".',
          'Selecione "Cadastrar Cliente" e preencha os dados necessários e o e-mail para login.',
          'Ative o campo "Permissão de Acesso" para liberar o acesso ao cliente.',
          'Habilite as áreas do sistema que o cliente terá acesso.',
          'Após salvar, o cliente receberá um e-mail com as instruções para criar uma senha e acessar o sistema.',
          'Após receber o e-mail, o cliente deve clicar no botão "Acessar meu sistema".',
          'Ele será redirecionado para a tela "Cadastrar nova senha", onde deverá inserir e confirmar a nova senha.',
        ],
      },
      {
        type: 'paragraph',
        content:
          'Ao clicar em "Cadastrar", será direcionado para a tela de login. Agora, basta acessar a aplicação com o e-mail e a senha cadastrados.',
      },
    ],
  },
  {
    category: 'payables',
    question:
      'O leitor automático de boletos não está reconhecendo o fornecedor ou a obra, o que pode estar acontecendo?',
    answers: [
      {
        type: 'paragraph',
        content:
          'Se o leitor automático de boletos não está identificando corretamente o fornecedor ou a obra, algumas situações podem estar causando esse problema:',
      },
      {
        type: 'list',
        items: [
          'Dados inconsistentes: Verifique se o CNPJ do fornecedor ou o CNPJ/CPF do cliente estão cadastrados corretamente no sistema. O leitor utiliza esses dados para fazer a correspondência automática.',
          'O cliente pode ter mais de uma obra ativa: Nesta situação, será necessário selecionar a obra manualmente.',
          'Formato do boleto: Alguns boletos podem ter variações no layout ou na disposição das informações, dificultando a leitura.',
          'Imagem ou PDF ilegível: Certifique-se de que o boleto está legível e com boa qualidade ao ser enviado para o sistema.',
        ],
      },
      {
        type: 'paragraph',
        content:
          'Se, após essas verificações, o problema persistir, entre em contato com o suporte para uma análise mais detalhada.',
      },
    ],
  },
  {
    category: 'budget',
    question:
      'O sistema não me habilita a criar um cronograma. O que pode estar acontecendo?',
    answers: [
      {
        type: 'paragraph',
        content:
          'Se o sistema não está permitindo a criação de um cronograma, pode ser devido à seguinte situação:',
      },
      {
        type: 'list',
        items: [
          'Orçamento não criado: O sistema cria o cronograma a partir do orçamento, portanto, inicie pelo orçamento. Assim que for criado, o cronograma ficará habilitado para ser gerado.',
        ],
      },
      {
        type: 'paragraph',
        content:
          'Caso tenha verificado esse ponto e o problema persistir, entre em contato com o suporte para uma análise mais detalhada',
      },
    ],
  },
  {
    category: 'budget',
    question:
      'Os campos "Total estimado inicial por M²", "Total executado por M²" e "Total estimado final por M²" estão zerados. O que pode estar acontecendo?',
    answers: [
      {
        type: 'paragraph',
        content:
          'Se esses campos estão aparecendo zerados, algumas situações podem estar causando esse problema:',
      },
      {
        type: 'list',
        items: [
          'M² da obra não informado: O sistema utiliza a metragem quadrada da obra para calcular os valores por metro quadrado. Certifique-se de que esse campo foi preenchido corretamente na edição ou criação do orçamento, pois sem essa informação, os cálculos não serão realizados.',
          'Orçamento não criado ou incompleto: O sistema utiliza os valores do orçamento para calcular esses totais. Confirme se o orçamento foi cadastrado e se todos os itens estão preenchidos.',
        ],
      },
      {
        type: 'paragraph',
        content:
          'Se, após essas verificações, os valores continuarem zerados, entre em contato com o suporte para uma análise mais detalhada.',
      },
    ],
  },
];

export const keyWords = [
  {
    label: 'Sobre o SIOON',
    value: 'about',
  },
  {
    label: 'Senha',
    value: 'password',
  },
  {
    label: 'Cliente',
    value: 'client',
  },
  {
    label: 'Obra',
    value: 'construction',
  },
  {
    label: 'Categoria',
    value: 'category',
  },
  {
    label: 'Personalização do sistema',
    value: 'customization',
  },
  {
    label: 'Lançamento',
    value: 'payables',
  },
  {
    label: 'Orçamento',
    value: 'budget',
  },
];
